import { useMutation } from 'react-query'

import { APIError } from '../../../utils'
import { SetInvoiceResponseData, setInvoiceStatus } from '../query-api'

interface UseSetInvoiceStatusProps {
  onError?: (error: APIError) => void
  onSuccess?: (data: SetInvoiceResponseData) => void
}

export const useSetInvoiceStatus = (props?: UseSetInvoiceStatusProps) => {
  const { onError, onSuccess } = props || {}

  const { mutate, isLoading, ...rest } = useMutation(setInvoiceStatus, {
    onSuccess,
    onError,
  })

  return { setInvoiceStatus: mutate, isProcessing: isLoading, ...rest }
}
